"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const moment_1 = __importDefault(require("moment"));
const i18next_1 = __importDefault(require("i18next"));
function default_1({ start_date, end_date, room_status_cd_id, }) {
    const startDate = (0, moment_1.default)(start_date);
    const endDate = (0, moment_1.default)(end_date);
    const isNotStarted = (0, moment_1.default)(startDate).isAfter();
    const isEndToday = endDate.isSame((0, moment_1.default)(), 'day');
    const dDay = Math.ceil(endDate.diff((0, moment_1.default)(), 'days', true));
    const isEnded = endDate.isSameOrBefore();
    const isNotOnSale = Boolean(room_status_cd_id) && room_status_cd_id !== 'ROOM_STATUS_01';
    const isNotStartedOrEndToday = isNotStarted || isEndToday;
    let dayLeftText = '';
    switch (true) {
        case isNotOnSale || isEnded:
            dayLeftText = i18next_1.default.t('마감');
            break;
        case isNotStarted:
            dayLeftText = i18next_1.default.t('오픈예정');
            break;
        case isEndToday:
            dayLeftText = i18next_1.default.t('오늘마감');
            break;
        default:
            dayLeftText = `D-${dDay}`;
    }
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: {
            display: 'flex',
            alignItems: 'center',
            height: '20px',
            padding: '0 6px',
            borderRadius: '100px',
            fontSize: '12px',
            backgroundColor: isNotStartedOrEndToday ? '#EB5757' : 'rgba(0, 0, 0, 0.7)',
            color: 'white',
        } }, { children: dayLeftText })));
}
exports.default = default_1;
